type Args = {
    evt: { currentTarget: { dataset: Record<string, string | undefined> } };
    router: { push: (url: string) => void; asPath: string };
    requiresAuth?: boolean;
    isLoggedIn?: boolean;
};

type AlertLinkClickHandler = (args: Args) => void;

export const alertLinkClickHandler: AlertLinkClickHandler = ({
    evt,
    router,
    requiresAuth = false,
    isLoggedIn = false
}) => {
    const destinationUrl = evt.currentTarget.dataset['url'] || router.asPath;
    const redirectUrl = encodeURIComponent(destinationUrl);

    if (requiresAuth && !isLoggedIn) {
        router.push(
            `${
                process.env['REGISTER_PATH'] || /register/
            }?page_after_login=${redirectUrl}&return_url=${redirectUrl}`
        );
    } else {
        destinationUrl && router.push(destinationUrl);
    }
};
